/* particlesJS.load(@dom-id, @path-json, @callback (optional)); 
particlesJS.load('particles-js', './wp-content/themes/qmodo/particlesjs-config.json', function() {
  console.log('callback - particles.js config loaded');
});*/


/* animated stat counter */
$(window).scroll(startCounter);
function startCounter() {
    if ($(window).scrollTop() > 500) {
        $(window).off('scroll', startCounter);
        $('.count').each(function () {
            var $this = $(this);
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                    $this.text(Math.ceil(this.Counter));
                }
            });
        });
    }
}

/* animated imagine ifs */
$(document).ready(function() {
    var quotes = $('.item');
    var quoteIndex = -1;
    
    function showNextQuote() {
        ++quoteIndex;
        quotes.eq(quoteIndex % quotes.length)
            .fadeIn(2000)
            .delay(9000)
            .fadeOut(2000, showNextQuote);
    }
    
    showNextQuote();
});

/* add drop shadow to menu on scroll */
$(window).scroll(function() {     
    var scroll = $(window).scrollTop();
    if (scroll > 16) {
        $('.site-top').addClass('active');
    }
    else {
        $('.site-top').removeClass('active');
    }
});

/* mobile menu */
$(document).ready(function() {
    jQuery('.drawer-nav-open-btn').click(function(e) {
        $('.drawer-nav').fadeIn(200);
		$('.drawer-nav-mask').fadeIn(200);
		$('body').toggleClass('lock-scroll');
        e.preventDefault();
    });
    
    jQuery('.drawer-nav-close-btn, .drawer-nav-close').click(function(e) {
        $('.drawer-nav').fadeOut(200);
		$('.drawer-nav-mask').fadeOut(200);
		$('body').removeClass('lock-scroll');
        e.preventDefault();
    });
});

/* mobile sub-menu */
$(document).ready(function(){
	$('.mobile-navigation__nav #top-menu li:nth-child(3)').click(function() {
		$('.sub-menu').slideToggle();
		$('.submenu-dropdown-toggle .icon').toggleClass('active');
	});
});

/* solution chart animation */
$(window).scroll(function() {     
    var scroll = $(window).scrollTop();
    if (scroll > 1500) {
        $('.chart__bar').addClass('slideInRight');
    }
    else {
        $('.chart__bar').removeClass('slideInRight');
    }
});

/* rotate icon */
$(document).ready(function(){
	$(".tab-label").click(function(){
		$(this).toggleClass("rotate")  ; 
	})
});

/* webinar countdown timer */
$(document).ready(function(){
	function makeTimer() {	
		var endTime = new Date("17 Jan 2024 11:00:00 GMT-05:00");			
			endTime = (Date.parse(endTime) / 1000);

			var now = new Date();
			now = (Date.parse(now) / 1000);

			var timeLeft = endTime - now;

			var days = Math.floor(timeLeft / 86400); 
			var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
			var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
			var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
			if (hours < "10") { hours = "0" + hours; }
			if (minutes < "10") { minutes = "0" + minutes; }
			if (seconds < "10") { seconds = "0" + seconds; }

			$("#days").html(days + "<span>Days</span>");
			$("#hours").html(hours + "<span>Hours</span>");
			$("#minutes").html(minutes + "<span>Minutes</span>");
			$("#seconds").html(seconds + "<span>Seconds</span>");		

	}

	setInterval(function() { makeTimer(); }, 1000);
});